import { sendSuccessNotice, sendErrorNotice, getCurrentTime } from '@/commons/utils';
import { request_detail, request_list, update_detail, create_detail, remove_detail } from '@/commons/hpod';
import configs from '@/configs'
import Vue from 'vue';
const endpoint = 'customers'

// initial state
const state = {
    loading: false,
    all: {},
    selected: {
        ID: 0,
        RoleID: 0,
        Status: 1,
        Username: '',
        FullName: '',
        PhoneNumber: '',
        is_active: 1,
        is_admin: 0
    }
};

// getters
const getters = {};

// actions
const actions = {
    getCustomerList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setCustomerList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getCustomerDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        request_detail(endpoint, data => {
            commit('setCustomerDetail', data);
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    removeCustomerDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice('Không thể xóa khách hàng.')
            }
            else {
                sendSuccessNotice('Đã xóa khách hàng thành công.')
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    setCustomerDetail({ commit }, {data, id, resetPwd}) {
        data.ModifiedDate = getCurrentTime().format(configs.SQL_DATE_FORMAT);
        data.ModifiedBy = this.state.authentication.user.userid;
        commit("setLoading", { loading: true });
        if(id > 0) {
            delete data.CreatedDate;
            delete data.Createdby;
            update_detail(endpoint, res => {
                if (res.data.status === 'fail') {
                    sendErrorNotice('Không thể cập nhật khách hàng.')
                }
                else if(resetPwd) {
                    sendSuccessNotice('Mật khẩu đã được reset về 123@456.')
                }
                else {
                    sendSuccessNotice('Cập nhật khách hàng thành công.')
                }
                commit("setLoading", { loading: false });
            }, Vue.http, data, id, this.state.authentication.token);
        }
        else {
            // data.CreatedDate = getCurrentTime().format(configs.SQL_DATE_FORMAT);
            data.Createdby = this.state.authentication.user.userid;
            create_detail(endpoint, res => {
                if (res.data.status === 'fail') {
                    if(res.data.error.includes('Duplicate entry'))
                    {
                        sendErrorNotice('Email đã tồn tại.')
                    }
                    else {
                        sendErrorNotice('Không thể thêm mới khách hàng.')
                    }
                }
                else {
                    sendSuccessNotice('Thêm mới khách hàng thành công, mật khẩu 123@456.')
                }
                commit("setLoading", { loading: false });
            }, Vue.http, data, this.state.authentication.token);
        }
    },
};

// mutations
const mutations = {
    setCustomerList(state, data) {
        state.all = data;
    },
    setCustomerDetail(state, item) {
        state.selected = item.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
